import { useEffect } from 'react';
import { useClient } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import { Pouzivatel } from '../model/iam/Pouzivatel';
import { fetchPouzivatelByRoleList } from '../client/external/iam/pouzivatelListClient';
import Uuid from '../model/Uuid';

interface ReturnType {
  pouzivatelia: Pouzivatel[];
  pouzivateliaStatus: ClientStatus;
}

export default (
  reloadData: boolean,
  setReloadData: (reloadData: boolean) => void,
  roleId: string,
  orgUuid?: Uuid,
): ReturnType => {
  const {
    wrapClient,
    data,
    status,
  } = useClient(fetchPouzivatelByRoleList);

  useEffect(() => {
    if (orgUuid && reloadData) {
      wrapClient(roleId, orgUuid, null);
      setReloadData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUuid, reloadData, roleId]);

  return {
    pouzivatelia: data,
    pouzivateliaStatus: status,
  };
};
